import 'slick-carousel/slick/slick';

$('.icon-slider').slick({
  autoplay: false,
  autoplaySpeed: 2000,
  arrows: true,
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  appendArrows: ".slider-navigation .arrows",
  appendDots: ".slider-navigation .dots",
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        adaptiveHeight: true,
        dots: false,
      },
    }
  ]
});
